import { render, staticRenderFns } from "./basic-card.vue?vue&type=template&id=3534dbcb"
import script from "./basic-card.vue?vue&type=script&lang=js"
export * from "./basic-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports